<template>
  <div>
    <trix-toolbar :id="toolbarId">
      <div class="trix-button-row">
        <span class="trix-button-group trix-button-group--text-tools">
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-bold"
            data-trix-attribute="bold"
            data-trix-key="b"
            title="Bold"
            tabindex="-1"
          >
            Bold
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-italic"
            data-trix-attribute="italic"
            data-trix-key="i"
            title="Italic"
            tabindex="-1"
          >
            Italic
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-strike"
            data-trix-attribute="strike"
            title="Strike"
            tabindex="-1"
          >
            Strike
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-link"
            data-trix-attribute="href"
            data-trix-key="k"
            title="Link"
            tabindex="-1"
          >
            Link
          </button>
        </span>

        <span class="trix-button-group trix-button-group--block-tools">
          <button
            type="button"
            class="trix-button"
            data-trix-attribute="heading1"
            title="Heading 1"
          >
            H1
          </button>
          <button
            type="button"
            class="trix-button"
            data-trix-attribute="heading2"
            title="Heading 2"
          >
            H2
          </button>
          <button
            type="button"
            class="trix-button"
            data-trix-attribute="heading3"
            title="Heading 3"
          >
            H3
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-bullet-list"
            data-trix-attribute="bullet"
            title="Bullets"
            tabindex="-1"
          >
            Bullets
          </button>
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-number-list"
            data-trix-attribute="number"
            title="Numbers"
            tabindex="-1"
          >
            Numbers
          </button>
        </span>

        <span class="trix-button-group trix-button-group--file-tools">
          <button
            type="button"
            class="trix-button trix-button--icon trix-button--icon-attach"
            data-trix-action="attachFiles"
            title="Attach Files"
            tabindex="-1"
          >
            Attach Files
          </button>
        </span>
      </div>

      <div class="trix-dialogs">
        <div
          class="trix-dialog trix-dialog--link"
          data-trix-dialog="href"
          data-trix-dialog-attribute="href"
        >
          <div class="trix-dialog__link-fields">
            <input
              type="url"
              name="href"
              class="trix-input trix-input--dialog"
              placeholder="Enter a URL…"
              aria-label="URL"
              required
              data-trix-input
            />
            <div class="trix-button-group">
              <input
                type="button"
                class="trix-button trix-button--dialog"
                value="Link"
                data-trix-method="setAttribute"
              />
              <input
                type="button"
                class="trix-button trix-button--dialog"
                value="Unlink"
                data-trix-method="removeAttribute"
              />
            </div>
          </div>
        </div>
      </div>
    </trix-toolbar>
    <trix-editor
      ref="trixEditor"
      :input="hiddenInputId"
      :toolbar="toolbarId"
      @trix-change="onEditorChange"
      @trix-attachment-add="handleAttachment"
      @trix-initialize="onEditorInit"
      @trix-file-accept="handleFileAccept"
    ></trix-editor>
    <input type="hidden" :id="hiddenInputId" :value="value" />
  </div>
</template>

<script>
import Trix from "trix";
import defaultSettings from "@/settings";
const { baseApi } = defaultSettings;

export default {
  name: "FormControlTrix",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  created() {
    Trix.config.blockAttributes.heading2 = {
      tagName: "h2",
      terminal: true,
      breakOnReturn: true,
      group: false,
    };
    Trix.config.blockAttributes.heading3 = {
      tagName: "h3",
      terminal: true,
      breakOnReturn: true,
      group: false,
    };
  },
  data() {
    const id = Math.random().toString(36).substring(2, 9);
    return {
      hiddenInputId: "trix-hidden-input-" + id,
      toolbarId: "trix-toolbar-" + id,
      editor: null,
      isTyping: false,
      checkerTimeout: null,
    };
  },
  watch: {
    value(newValue) {
      if (!this.isTyping && this.editor) {
        this.$nextTick(() => {
          this.editor.loadHTML(newValue || "");
        });
      }
    },
  },
  methods: {
    onEditorInit(event) {
      this.editor = event.target.editor;
      if (this.value) {
        this.editor.loadHTML(this.value);
      }
    },
    onEditorChange(event) {
      this.isTyping = true;
      if (this.checkerTimeout) clearTimeout(this.checkerTimeout);
      this.checkerTimeout = setTimeout(() => {
        this.isTyping = false;
      }, 300);
      this.$emit("input", event.target.value);
    },
    handleFileAccept(event) {
      const { file } = event;
      if (!file.type.startsWith("image/")) {
        event.preventDefault();
        alert(
          "Разрешены только изображения .webp, .png, .jpeg, .jpg для загрузки."
        );
      }
    },
    handleAttachment(event) {
      const attachment = event.attachment;
      if (attachment.file) {
        this.uploadAttachment(attachment);
      }
    },
    uploadAttachment(attachment) {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", baseApi + "/api/admin/files/", true);
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          const json = JSON.parse(xhr.responseText);
          attachment.setAttributes({
            url: baseApi + json.url,
            href: baseApi + json.url,
          });
        } else {
          console.error("File upload failed", xhr.status, xhr.responseText);
        }
      };
      xhr.onerror = () => {
        console.error("File upload failed");
      };
      const formData = new FormData();
      formData.append("file", attachment.file);
      xhr.send(formData);
    },
  },
};
</script>
<style>
trix-editor {
  line-height: 1;
}
</style>
